import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { routesURLs } from '../../Routes'
import OnlineMockExamCourseLesson from './OnlineMockExamCourseLesson'
import OnlineMockExamCourseLessonDetail from './OnlineMockExamCourseLessonDetail'

const OnlineMockExamCourse = () => {
  return (
    <Switch>
      <Route
        path={`${routesURLs.onlineMockExamCourse}/:courseId/:lessonId`}
        exact={true}
        render={(props) => <OnlineMockExamCourseLessonDetail {...props} />}
      />
      <Route
        path={`${routesURLs.onlineMockExamCourse}/:id`}
        exact={true}
        render={(props) => <OnlineMockExamCourseLesson {...props} />}
      />
    </Switch>
  )
}

export default OnlineMockExamCourse
